import { createFileRoute } from '@tanstack/react-router'
import GameRecords from '@/features/game-records'

export const Route = createFileRoute('/_authenticated/game-records/')({
  component: GameRecords,
})
